import type { MouseEventHandler, Ref } from "react";

import { Backdrop, Container, Duration, PlayButton } from "./styles";

export type Props = {
  className?: string;
  duration?: string;
  imageSource?: string;
  onClick: MouseEventHandler<HTMLDivElement>;
  orientation?: "landscape" | "portrait";
  ref?: Ref<HTMLDivElement>;
};

export const SCMPYoutubeVideoPreview = ({
  className,
  duration,
  imageSource,
  onClick,
  orientation,
  ref,
}: Props) => (
  <Container
    $backgroundImage={imageSource}
    $orientation={orientation}
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <Backdrop />
    <PlayButton />
    {duration && <Duration>{duration}</Duration>}
  </Container>
);

SCMPYoutubeVideoPreview.displayName = "SCMPYoutubeVideoPreview";
